import React from 'react';

const PageIndicator = (props) => {

    return (
        <div className="optimized__d-flex-class flex-row-reverse justify-content-center align-items-center py-2">
            <span className={props.current == "1" ? "indicator__item--selected" : "indicator__item"}>۱</span>
            <span className="indicator__separator"><i className="simple-icon-arrow-right indicator__separator-icon"></i></span>
            <span className={props.current == "2" ? "indicator__item--selected" : "indicator__item"}>۲</span>
            <span className="indicator__separator"><i className="simple-icon-arrow-right indicator__separator-icon"></i></span>
            <span className={props.current == "3" ? "indicator__item--selected" : "indicator__item"}>۳</span>
            <span className="indicator__separator"><i className="simple-icon-arrow-right indicator__separator-icon"></i></span>
            <span className="indicator__separator"><i className="simple-icon-check indicator__check-icon"></i></span>
        </div>
    );
}

export default PageIndicator;